function createUnconfiguredDynamicCalendar($, $ajax, options) {
    const { unitId, from } = options.parameters;
    const afterCalendarLoadedCallbacks = [];
    let monthStep = 0;

    loadCalendar();
    options.$calendarContent.on('click', '.calendarLeft', showPrevMonth);
    options.$calendarContent.on('click', '.calendarRight', showNextMonth);

    function showNextMonth() {
        monthStep += 1;
        loadCalendar();
    }

    function showPrevMonth() {
        monthStep -= 1;
        loadCalendar();
    }

    function loadCalendar() {
        const deferred = $.Deferred();
        const calendarPromise = $ajax(options.url, { monthStep, unitId, from });

        calendarPromise.then((calendar) => {
            options.$calendarContent.html(calendar);
            deferred.resolve(calendar);
        });

        deferred.promise().then(() => {
            afterCalendarLoadedCallbacks.forEach((callback) => {
                callback({ monthStep });
            });
        });
    }

    return {
        afterCalendarLoaded: function afterCalendarLoaded(callback) {
            afterCalendarLoadedCallbacks.push(callback);
        },
    };
}

const createDynamicCalendar = (options) => createUnconfiguredDynamicCalendar.bind(null, $, $.post, options);

export { createDynamicCalendar };
export { createUnconfiguredDynamicCalendar };
